module.exports = __webpack_public_path__ + "assets/img/btn_AppStore-1c598f2e.png";